'use strict';

import modalDirective from 'brg/rest/buttons/modal';
import resolveUsers from 'utils/resolve/users';

import template from './template.html';

export default modalDirective({
	template: template,
	controller: controller,
	resolve: {
		users: resolveUsers,
	}
});


function controller($scope, $http) {
	'ngInject';

	$scope.submitting = false;
	$scope.errors = null;

	$scope.submitData = function() {
		if ($scope.submitting) return;
		$scope.submitting = true;
		const url = '/api/teams/beats/call_profiles/create/';
		const data = {
			beat_id: $scope.$context.beat.uuid,
			user_id: $scope.selectedUser.uuid,
			start_seconds: $scope.startMinutes*60,
			stop_seconds: $scope.stopMinutes*60,
		};

		$http({
			method: 'POST',
			url: url,
			data: data,
		}).then((response) => {
			$scope.$close(response.data);
		}, (error) => {
			console.error(error);
			$scope.errors = error.data;
		}).finally(() => {
			$scope.submitting = false;
		});
	}
}
